export const COLOR_HIGHLIGHT_CLASS = 'selected';

// FIXME: once selections are in the state, we'll be able to apply the state to elements found in the state,
// instead of being force to look into the document.
function highlightSelectionByUuid(uuid) {
  document.querySelectorAll(`.annotation-${uuid}`).forEach((e) => e.classList.add(COLOR_HIGHLIGHT_CLASS));
}

function removeSelectionHighlightByUuid(_, uuid) {
  document.querySelectorAll(`.annotation-${uuid}`).forEach((e) => e.classList.remove(COLOR_HIGHLIGHT_CLASS));
}

function removeAllSelectionHighlights(_) {
  document
    .querySelectorAll(`.pdf-viewer__annotation.${COLOR_HIGHLIGHT_CLASS}`)
    .forEach((e) => e.classList.remove(COLOR_HIGHLIGHT_CLASS));
}

function removeTemporaryHighlight() {
  document.querySelectorAll(`.annotation-temporary`).forEach((node) => node.parentNode.removeChild(node));
  document.querySelectorAll(`.annotation-anchor-temporary`).forEach((node) => node.parentNode.removeChild(node));
}
function getTextLinkModalOffset() {
  const isSidebarCollapsed = localStorage.getItem('isSidebarCollapsed') === 'true';
  return isSidebarCollapsed ? 65 : 65 + 164;
}

export {
  highlightSelectionByUuid,
  removeAllSelectionHighlights,
  removeSelectionHighlightByUuid,
  removeTemporaryHighlight,
  getTextLinkModalOffset,
};
